module.exports = __webpack_public_path__ + "media/images/favicons/android-chrome-384x384-d3bb6c1954e0f90f049c3006a9532c71.png";